export default __webpack_public_path__ + "static/blob9-e80f749ee6815ec7427e27e61ca318c1.svg";